import { FunctionComponent, ReactNode } from 'react';
import { Asset, Box, Typography } from '@altermaind/web/ui';

type Props = {
  title: string;
  subTitle: string;
  logo?: string;
  logoWidth?: number;
  childrenLogin?: ReactNode;
};

export const LoginForm: FunctionComponent<Props> = ({
  title,
  subTitle,
  logo,
  logoWidth = 62,
  childrenLogin,
}) => {
  return (
    <Box
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      height='100vh'
      display='flex'
      maxWidth='100%'
      style={{
        position: 'absolute',
        left: 0,
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)',
        height: 'auto',
      }}
    >
      <Box alignItems='center' mb='xxxl' paddingTop='huge'>
        {logo && <Asset domain='images' name={logo} width={logoWidth} />}
      </Box>
      <Typography textAlign='center' variant='h1' fontSize='xxxl'>
        {title}
      </Typography>
      <Typography variant='h2/light' mt='xxs'>
        {subTitle}
      </Typography>

      {childrenLogin}
    </Box>
  );
};
